<template>
  <nav>
    <v-navigation-drawer v-model="drawer" app :clipped="$vuetify.breakpoint.lgAndUp">
      <v-list>
        <v-list-item v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-item-action>
            <v-icon class="grey--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <!-- <v-list-item-title class="white--text">Dashboard</v-list-item-title> -->
            <v-list-item-title class="grey--text">
              {{
              link.text
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app flat class="primary" :clipped-left="$vuetify.breakpoint.lgAndUp">
      <v-app-bar-nav-icon class="white--text"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ma-0 pa-0">
        <v-img
          src="../assets/nutechlogo.png"
          contain
          max-height="43"
          max-width="96"
          class="ml-4 pa-0"
        ></v-img>
      </v-toolbar-title>
      <v-text-field
        :append-icon-cb="() => {}"
        placeholder="Search staff"
        single-line
        append-icon="mdi-magnify"
        color="white"
        hide-details
        class="ml-6"
      ></v-text-field>
      <v-spacer></v-spacer>

      <v-btn text>
        <v-icon class="white--text">mdi-map-marker</v-icon>
        <span class="text-none ml-3 white--text">Nutech Security | Headoffice</span>
      </v-btn>
      <v-btn text @click="setAudioOn()" class="error" id="soundcontrolbtn">
        <v-icon class="white--text">{{ soundon }}</v-icon>
        <span class="text-none ml-3 white--text">{{ soundtext }}</span>
      </v-btn>
      <!-- <h3 class="font-weight-thin text-no-wrap">Nutech Security Headoffice</h3> -->
      <v-btn text>
        <v-icon lfet class="white--text">mdi-account</v-icon>
        <span class="text-none ml-3 white--text">Admin</span>
      </v-btn>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      soundon: "mdi-volume-off",
      soundtext: "Panic audio off",
      drawer: null,
      links: [
        { icon: "mdi-map-search", text: "Map monitor", route: "/" },
        {
          icon: "mdi-clipboard-account-outline",
          text: "Asign Card",
          route: "/asigncard"
        },
        {
          icon: "mdi-cog-outline",
          text: "Configuration",
          route: "/configuration"
        },
        {
          icon: "mdi-comment-quote-outline",
          text: "Feedback",
          route: "/feedback"
        }
      ]
    };
  },
  created: function() {
    document.body.addEventListener("click", () => {
      this.setAudioOn();
    });
  },
  methods: {
    setAudioOn: function() {
      this.soundon = "mdi-volume-high";
      this.soundtext = "Panic audio on";
      document.getElementById("soundcontrolbtn").classList.remove("error");
      document.getElementById("soundcontrolbtn").classList.add("success");
    }
  }
};
</script>

<style scoped>
.breadcrumbdata {
  position: relative;
  top: 300px;
  left: 20px;
}
</style>
